var loginInfo = require('utils/loginInfo.js');


loginInfo.info.then(function(rsp){
    if(rsp.result){
      module.exports.isLogin = true;
    }
});
module.exports = {
  isLogin: false
}



//////////////////
// WEBPACK FOOTER
// /data/services/vipm-hdplfm/server/pagefactory/components/avalon/TextButton/util.js
// module id = 3
// module chunks = 0